import
{
    inTestMode,
    parseBooleanConfigSettingDefaultDisabled,
    parseBooleanConfigSettingDefaultEnabled
}
    from "ui-common/AppSettings";

// [Global variables]
let test_mode_overrides = { };

let next_gen_enabled = false;

export const saveScanImagesEnabled = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_SAVE_SCAN_FAIL_IMAGES);
}

export const saveScanSuccessImagesEnabled = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_SAVE_SCAN_SUCCESS_IMAGES);
}

export const allowSkipQuestions = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_ALLOW_SKIP_QUESTIONS);
}

export const oneTrustPatientComponent = process.env.REACT_APP_ONE_TRUST_PATIENT_COMPONENT
export const oneTrustPatientJs = process.env.REACT_APP_ONE_TRUST_PATIENT_JS
export const oneTrustPatientNotice = process.env.REACT_APP_ONE_TRUST_PATIENT_NOTICE

export const shouldShowEUPrivacyAgreement = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_SHOW_EU_PRIVACY_AGREEMENT);
}

export const isSurveyLoggingEnabled = () => {
    return parseBooleanConfigSettingDefaultEnabled(process.env.REACT_APP_SURVEY_LOGGER_ENABLED);
}

export const brightcoveAccountId = process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID;
export const brightcovePlayerId = process.env.REACT_APP_BRIGHTCOVE_PLAYER_ID;

export const isManualMeasurementEnabled = () => {
    return parseBooleanConfigSettingDefaultEnabled(process.env.REACT_APP_SHOW_MANUAL_MEASUREMENT);
}

export const shouldFastClickQuestions = () => {

    if ( inTestMode() && "TEST_MODE_FAST_CLICK_QUESTIONS" in test_mode_overrides ) {
        return parseBooleanConfigSettingDefaultDisabled(test_mode_overrides["TEST_MODE_FAST_CLICK_QUESTIONS"]);
    }

    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_FAST_CLICK_QUESTIONS);
}

export const isNextGenEnabled = () => {
    return parseBooleanConfigSettingDefaultDisabled(next_gen_enabled);
}

export const setNextGenEnabled = (value) => {
    next_gen_enabled = value;
}

export const isNextGenLogsEnabled = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_NEXT_GEN_LOGS_ENABLED);
}

export const isNextGenSaveMugshotsEnabled = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_NEXT_GEN_SAVE_MUGSHOTS_ENABLED);
}

export const nextGenApiBaseUrl = process.env.REACT_APP_NEXT_GEN_API_BASE_URL;

export const playAudioInstructions = () => {
    return parseBooleanConfigSettingDefaultEnabled(process.env.REACT_APP_PLAY_AUDIO_INSTRUCTIONS);
}

export const isCookieForPersonalInformationEnabled = () => {
    return parseBooleanConfigSettingDefaultDisabled(process.env.REACT_APP_PERSONAL_INFORMATION_COOKIE_ENABLED)
}


// =====================================================================================================================

export const setTestModeShouldFastClickQuestions = (value) => {
    if ( inTestMode() ) {
        test_mode_overrides["TEST_MODE_FAST_CLICK_QUESTIONS"] = value;
    }
}